import { createState } from "./zustand_store";

export const useMlbBallparkStore = createState({
  mlbBallparkOktaId: null,
});
